module.exports = __webpack_public_path__ + "media/images/recruit/description/logo-sigfy-19d6698d36a8baa08e978a90c7493a44.png";